import {
  TextField,
  NumberField,
  DateField,
  TextInput,
  NumberInput,
  SelectInput,
} from "react-admin";
import { ActionTypeField } from "./actionTypeField";

export const hostLogFields = [
  { name: "id", component: NumberField, props: { sortable: false } },
  { name: "package_id", component: NumberField, props: { sortable: false } },
  { name: "host_id", component: NumberField, props: { sortable: false } },
  { name: "locker_id", component: NumberField, props: { sortable: false } },
  { name: "host_email", component: TextField, props: { sortable: false } },
  { name: "tower_id", component: TextField, props: { sortable: false } },
  { name: "action_type", component: ActionTypeField, props: {} },
  {
    name: "host_open_reason",
    component: TextField,
    props: { sortable: false },
  },
  { name: "host_open_notes", component: TextField, props: { sortable: false } },
  { name: "created_at", component: DateField, props: { sortable: false } },
];

export const HOST_LOG_ACTION_LABELS = {
  1: "confirm_pickup",
  2: "out_of_service",
  3: "open",
  4: "tower_activated",
  5: "tower_deactivated",
};

export const HOST_OPEN_REASONS = {
  clearing_locker: "Clearing Locker",
  door_wont_open: "Door Won't Open",
  other: "Other",
};

export const hostLogFilters = [
  <NumberInput label="Package ID" source="package_id" alwaysOn key="package" />,
  <NumberInput label="Host ID" source="host_id" alwaysOn key="host" />,
  <TextInput label="Host Email" source="email" alwaysOn key="host_email" />, // 👈 Added
  <TextInput label="Tower ID" source="tower_id" alwaysOn key="tower" />,
  <NumberInput label="Locker ID" source="locker_id" alwaysOn key="locker" />,
  <SelectInput
    key="action"
    source="action_type"
    label="Action Type"
    choices={Object.entries(HOST_LOG_ACTION_LABELS).map(([id, name]) => ({
      id: parseInt(id),
      name,
    }))}
    alwaysOn
  />,
  <SelectInput
    key="reason"
    source="host_open_reason"
    label="Host Open Reason"
    choices={Object.entries(HOST_OPEN_REASONS).map(([id, name]) => ({
      id,
      name,
    }))}
    alwaysOn
  />,
];
